export const convertDateToDatMonthNameYearObject = (dateString: any) => {
  const date = new Date(dateString.replace(' ', 'T'));
  // const options = {year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'};
  const convertedDate = {
    day: date.getDate(),
    month: date.toUTCString().split(' ')[2],
    year: date.getFullYear(),
    hour: [date.getHours(), String(date.getMinutes()).padStart(2, '0')].join(':'),
  };
  // [
  //   convertedDate.day,
  //   convertedDate.month,
  //   convertedDate.year,
  //   convertedDate.hour,
  // ] = date.toLocaleDateString('pl-PL', options).split(' ');
  // toLocaleDateString returns year with comma at the end, this line removes it
  // convertedDate.year = convertedDate.year.slice(0, -1);
  return convertedDate;
};
